<template>
  <div class="order-info-main-container">
    <div class="back-button-container" @click="goTo(routes.ticketSeller.orders)">
      <div class="back-button-icon-container">
        <img class="back-button-icon" src="/assets/back-icon.svg" :alt="adminText('workflowsAll.back_button_4e9e2cc', 'Back Button')">
      </div>
      <div class="back-button-text-container">{{ adminText('workflowsAll.back_to_orders_f02399a', 'Back to orders') }}</div>
    </div>
    <div class="order-info-container">
      <div class="order-info-title">{{ adminText('workflowsAll.order_f1e486f', 'Order #') }}{{ workflowLabel(orderId) }}</div>
      <div class="order-info-date">
        {{ adminText('workflowsAll.proccessed_at_e8e02d4', 'Proccessed at') }}
        {{ workflowLabel(processedAt) }}
      </div>
      <div class="order-info-event-title">
        {{ workflowLabel(event.title) }}
      </div>
      <div class="order-info-event-date-and-location">
        {{ workflowDate(moment(event.from).locale('en'), 'MMM DD, YYYY [at] HH:mm') }}
        @
        {{ workflowLabel(event.location ? event.location.venue : '') }}
      </div>
      <div v-if="!eventFinished" class="order-info-buttons">
        <div
          v-if="eventHasTickets"
          class="order-info-link-button"
          @click="goTo(routes.ticketSeller.purchase, { eventId: event.id })"
        >
          <div class="order-info-link">{{ adminText('workflowsAll.go_to_tickets_61fd0fb', 'Go to tickets') }}</div>
          <div class="order-info-link-icon-container">
            <img class="order-info-link-icon" src="/assets/goto-icon.svg" :alt="adminText('workflowsAll.go_to_button_afb193e', 'Go to button')">
          </div>
        </div>
        <div class="order-info-link-button" @click="goToPublicPage">
          <div class="order-info-link">{{ adminText('workflowsAll.view_event_page_45f6c2c', 'View event page') }}</div>
          <div class="order-info-link-icon-container">
            <img class="order-info-link-icon" src="/assets/goto-icon.svg" :alt="adminText('workflowsAll.go_to_button_afb193e', 'Go to button')">
          </div>
        </div>
      </div>
      <div class="order-info-items-container">
        <div v-for="ticket of countDuplicate()" :key="ticket.id">
          <div class="order-info-item-summary-container">
            <div class="order-info-item-container">
              {{ workflowLabel(ticket.count) }}
              {{ adminText('workflowsAll.copy_67fba2f', '×') }}
              {{ workflowLabel(ticket.name) }}
            </div>
            <div class="order-info-item-price-container">
              {{ workflowLabel(calculateTicketPrice(ticket.count * ticket.price, ticket.currency)) }}
            </div>
          </div>
        </div>
        <div v-if="fixedFeeItems.length">
          <div v-for="(fee, index) in fixedFeeItems" :key="index + 1">
            <div class="order-info-item-summary-container">
              <div class="order-info-item-container">
                {{ workflowLabel(fee.count) }}
                {{ adminText('workflowsAll.copy_67fba2f', '×') }} {{ workflowLabel(fee.name) }}
              </div>
              <div class="order-info-item-price-container">{{ workflowLabel(round(fee.totalPrice, 2)) }} EUR</div>
            </div>
          </div>
        </div>
      </div>
      <div class="order-info-total-container">
        <div class="order-info-total-text">{{ adminText('workflowsAll.total_b25928c', 'Total') }}</div>
        <div class="order-info-total-amount">
          {{ workflowLabel(price) }}
        </div>
      </div>
      <div class="order-info-vat-container">{{ adminText('workflowsAll.vat_is_included_e9c65e8', 'VAT is included.') }}</div>
    </div>
    <div v-if="status !== OrderStatusEnum.REFUNDED" class="buttons-container">
      <a
        v-if="status === OrderStatusEnum.SUCCESSFUL"
        id="print-button"
        class="order-info-button print"
        target="_blank"
        @click="handleTicketPrint()"
      >
        <span class="buttons-text">{{ adminText('workflowsAll.print_tickets_f99b47a', 'PRINT TICKETS') }}</span>
      </a>
      <button
        class="order-info-button refund"
        :class="refundRequested || status !== OrderStatusEnum.SUCCESSFUL || refundInProgress ? 'disabled' : ''"
        type="button"
        :disabled="refundRequested || status !== OrderStatusEnum.SUCCESSFUL || refundInProgress"
        @click="handleRefundButtonClick"
      >
        <span class="buttons-text">
          {{ workflowLabel(refundButtonText) }}
          <span v-if="refundInProgress" class="spinner" />
        </span>
      </button>
    </div>
    <div v-else class="refunded-message-container">
      {{ adminText('workflowsAll.this_order_has_been_refunded_on_dae0295', 'This order has been refunded on') }} {{ refundedAtPresentation }}.
    </div>
    <v-dialog v-model="confirmDialogOpen" persistent max-width="480px">
      <v-card class="refund-confirm-card">
        <div class="refund-confirm-title">{{ adminText('workflowsAll.confirm_refund_6038506', 'Confirm refund') }}</div>
        <div class="refund-confirm-text">
          {{ adminText('workflowsAll.are_you_sure_you_want_to_refund_order_33186df', 'Are you sure you want to refund order #') }}{{ workflowLabel(orderId) }}{{ adminText('workflowsAll.this_cannot_be_undone_0c7fd3f', '? This cannot be undone.') }}
        </div>
        <div class="refund-confirm-actions">
          <button class="refund-confirm-button cancel" type="button" @click="confirmDialogOpen = false">
            {{ adminText('workflowsAll.cancel_77dfd21', 'Cancel') }}
          </button>
          <button class="refund-confirm-button confirm" type="button" @click="confirmDirectRefund">
            {{ adminText('workflowsAll.refund_e17c8ad', 'Refund') }}
          </button>
        </div>
      </v-card>
    </v-dialog>
    <simple-snackbar
      :open.sync="snackbar.open"
      :message-prop="workflowLabel(snackbar.message)"
      :color="snackbar.color"
    />
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export const frontendURL = process.env.VUE_APP_FRONTEND_URL
import { GET_TICKET_SELLERS_ORDER, REQUEST_REFUND_TICKET_SELLER } from '@/graphql/order.graphql'
import { landingURL } from '@/utils'
import SimpleSnackbar from '../../shared/snackbars/simple-snackbar.vue'
import moment from 'moment'
import { CoreEventFeeType, OrderStatusEnum } from '@/types'
import { round } from 'lodash'

export default {
  mixins: [WorkflowDisplay],
  components: {
    SimpleSnackbar,
  },
  props: {
    orderId: {
      type: Number | String,
      default: null,
    },
  },
  data() {
    return {
      price: '',
      processedAt: '',
      status: '',
      orderItems: [],
      uuid: '',
      fixedFeeItems: [],
      snackbar: {
        open: false,
        message: '',
        color: '',
      },
      refundRequested: false,
      refundButtonText: 'workflowsAll.request_a_refund_db34663',
      directRefundAvailable: false,
      refundInProgress: false,
      confirmDialogOpen: false,
      OrderStatusEnum,
      refundedAt: null,
      refundedAtTimestamp: null,
      fixedCoreEventFeePerTicket: 0,
      order: null,
      event: {},
      totalTicketCount: 0,
      buyer: {},
      paymentType: null,
      eventFinished: true,
      eventHasTickets: false,
      moment,
    }
  },
  apollo: {
    getTicketSellersOrder: {
      query: GET_TICKET_SELLERS_ORDER,
      variables() {
        return {
          orderId: this.orderId,
        }
      },
      result({ data, loading }) {
        if (!loading && data) {
          const { getTicketSellersOrder: order } = data
          this.event = order.event
          this.buyer = order.buyer
          if (moment(order.event.to).isAfter(moment(new Date()))) {
            this.eventFinished = false
          }

          if (order.event.orderItems.length > 0) {
            this.eventHasTickets = true
          }
          this.directRefundAvailable = order.directRefundAvailable
          if (order.status === this.OrderStatusEnum.REFUND_REQUESTED) {
            this.refundRequested = true
            this.refundButtonText = 'workflowsAll.refund_requested_76b1f27'
          } else if (order.directRefundAvailable) {
            this.refundButtonText = 'workflowsAll.make_a_refund_481dd29'
          }
          if (order.refundedAt) {
            this.refundedAtTimestamp = order.refundedAt
            this.refundedAt = moment(order.refundedAt).format('DD.MM.YYYY. [at] HH:mm [h]')
          }

          this.processedAt = moment(order.createdAt).format('DD.MM.YYYY. HH:mm')

          this.paymentType = this.getOrderPaymentType(order)
          this.price = this.calculateOrderTotalPrice(order.price, this.paymentType)
          this.orderItems = order.purchases.map(purchase => purchase.orderItem)
          this.uuid = order.uuid
          this.status = order.status
          this.useCoreEventFeeIfNeeded(order)
        }
      },
      error(error) {
        this.goTo(this.routes.ticketSeller.orders)
      },
    },
  },
  computed: {
    refundedAtPresentation() {
      return this.refundedAtTimestamp ? this.workflowDate(this.refundedAtTimestamp, 'DD.MM.YYYY. [at] HH:mm [h]') : this.refundedAt
    },
  },
  methods: {
    round,
    useCoreEventFeeIfNeeded(order) {
      if (order.fiscalisationInfo.useEventFeePerTicket) {
        this.fixedFeeItems = order.fiscalisationInfo.fiscalisationError
          ? []
          : order.fiscalisationInfo['full_receipt'].items
            .map(i => {
              if (i.name.includes(CoreEventFeeType.TICKET)) {
                return {
                  name: i.name,
                  count: i.amt / 1000,
                  totalPrice: i.price / 100,
                  singleItemPrice: i['single_item_price'] / 100,
                }
              }
            })
            .filter(Boolean)
        this.countDuplicate().map(i => (this.totalTicketCount += i.count))
        this.fixedCoreEventFeePerTicket = order.fiscalisationInfo.eventTicketFee * 1.25
      }
    },
    calculateOrderTotalPrice(price, paymentType) {
      let newPrice = Number(price.split(' ')[1])
      if (paymentType === 'FREE') {
        newPrice = 0
      }

      return `EUR ${newPrice}`
    },
    getOrderPaymentType(order) {
      return (order.buyer && order.buyer.paymentType) || order.paymentType
    },
    calculateTicketPrice(price, currency) {
      const paymentType = this.paymentType
      let newPrice = Number(price)
      if (paymentType === 'FREE') {
        newPrice = 0
      } else if (paymentType === 'KEKS10') {
        newPrice = round(newPrice * 0.9, 2)
      } else if (paymentType === 'TELEGRAM20' || paymentType === 'POPUST20') {
        newPrice = round(newPrice * 0.8, 2)
      } else if (paymentType === 'Popust40') {
        newPrice = round(newPrice * 0.6, 2)
      } else if (paymentType === 'Popust50') {
        newPrice = round(newPrice * 0.5, 2)
      } else if (['CASH20', 'CARD20', 'CASH50', 'CARD50'].includes(paymentType)) {
        if (paymentType.endsWith('20')) {
          newPrice = round(newPrice * 0.8, 2)
        } else {
          newPrice = round(newPrice * 0.5, 2)
        }
      }

      return `${round(newPrice, 2)} ${currency}`
    },
    countDuplicate() {
      return Object.values(
        this.orderItems.reduce((r, e) => {
          let k = `${e.id}`
          if (!r[k])
            r[k] = {
              ...e,
              count: 1,
            }
          else r[k].count += 1

          return r
        }, {}),
      )
    },

    handleTicketPrint() {
      const url = `${frontendURL}/ticket-seller/print/${this.uuid}`
      window.open(url, '_blank')
    },

    handleRefundButtonClick() {
      if (this.directRefundAvailable) {
        this.confirmDialogOpen = true
      } else {
        this.handleRequestRefund()
      }
    },

    async confirmDirectRefund() {
      this.confirmDialogOpen = false
      await this.handleRequestRefund()
    },

    showRefundError() {
      this.snackbar.open = true
      this.snackbar.message = (this.directRefundAvailable ? 'workflowsAll.something_went_wrong_while_processing_the_ref_23ba9e0' : 'workflowsAll.something_went_wrong_while_requesting_the_ref_beaf39a')
      this.snackbar.color = 'error'
    },

    async handleRequestRefund() {
      if (this.refundInProgress) {
        return
      }
      this.refundInProgress = true
      try {
        const { data } = await this.$apollo.mutate({
          mutation: REQUEST_REFUND_TICKET_SELLER,
          variables: {
            orderId: this.orderId,
          },
        })

        const result = data && data.requestRefundTicketSeller
        if (result && result.success) {
          if (this.directRefundAvailable) {
            this.snackbar.open = true
            // A refund can go through while its fiscal reversal fails; that needs its own
            // message so the seller knows to verify the invoice rather than retry.
            this.snackbar.message =
              (result.fiscalReversalFailed && result.message ? result.message : 'workflowsAll.order_refunded_8b9b18c')
            this.snackbar.color = result.fiscalReversalFailed ? 'warning' : 'primary'
            await this.$apollo.queries.getTicketSellersOrder.refetch()
          } else {
            this.snackbar.open = true
            this.snackbar.message = 'workflowsAll.refund_successfully_requested_24e7221'
            this.snackbar.color = 'primary'
            this.refundRequested = this.OrderStatusEnum.REFUND_REQUESTED
          }
        } else {
          this.showRefundError()
        }
      } catch (e) {
        this.showRefundError()
      } finally {
        this.refundInProgress = false
      }
    },
    goToPublicPage() {
      window.open(`${landingURL}/events/${this.event.slug}`)
    },
  },
}
</script>

<style scoped>
.back-button-container {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  cursor: pointer;
  width: fit-content;
}

@media only screen and (max-width: 800px) {
  .back-button-container {
    margin-top: 0.5rem;
    margin-bottom: 0;
  }
}

.back-button-icon-container {
  margin-right: 1rem;
  display: flex;
  align-items: center;
}

.back-button-icon {
  height: 1rem;
}

.back-button-text-container {
  font-family: 'Raleway', sans-serif;
  font-size: 1.25rem;
  font-weight: bold;
  color: #ff4c00;
  line-height: 120%;
  letter-spacing: -0.015em;
}

.order-info-container {
  max-width: 42.25rem;
  background-color: #f5f5f5;
  padding: 2.5rem 3rem;
  border-radius: 2rem;
}

.order-info-title {
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 2.25rem;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
  margin-bottom: 0.5rem;
}

.order-info-date {
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 150%;
  color: #666666;
}

.order-info-event-title {
  margin-top: 1rem;
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 120%;
  letter-spacing: -0.03em;
  color: #0277bd;
}

.order-info-event-date-and-location {
  margin: 0.5rem 0;
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 120%;
  color: #666666;
}

.order-info-buttons {
  display: flex;
  margin-bottom: 0.5rem;
}

.order-info-link-button {
  display: flex;
  width: fit-content;
  align-items: center;
  cursor: pointer;
}

.order-info-link-button:not(:first-child) {
  margin-left: 1rem;
}

.order-info-link {
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 120%;
  letter-spacing: -0.015em;
  color: #0277bd;
  margin-right: 0.25rem;
}

.order-info-link-icon-container {
  display: flex;
}

.order-info-item-summary-container {
  padding: 1rem 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid #979797;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 1.125rem;
  line-height: 150%;
  color: #666666;
}

.order-info-total-container {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.order-info-total-text {
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 1.25rem;
  line-height: 150%;
  letter-spacing: -0.015em;
  color: #333333;
}

.order-info-total-amount {
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 2rem;
  line-height: 150%;
  letter-spacing: -0.015em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #333333;
}

.order-info-vat-container {
  margin-top: 0.2rem;
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 150%;
  color: #979797;
}

.buttons-container {
  margin-top: 1.5rem;
  max-width: 42.25rem;
  display: flex;
}

.order-info-button {
  border-radius: 1.25rem;
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 1.125rem;
  line-height: 120%;
  letter-spacing: -0.015em;
  padding: 0.5rem 1rem;
  text-transform: uppercase;
}

.order-info-button.print {
  width: fit-content;
  display: flex;
  color: white;
  background-color: #0277bd;
  margin-right: 0.75rem;
}

.order-info-button.refund {
  box-sizing: border-box;
  color: #0277bd;
  border: 2px solid #0277bd;
  background-color: white;
}

.order-info-button.disabled {
  background-color: #f5f5f5;
  color: #979797;
  border: 2px solid #979797;
}

.order-info-button.print.disabled:hover {
  cursor: default;
}

.refunded-message-container {
  max-width: 676px;
  margin-top: 1.5rem;
  padding: 0.5rem 1rem;
  background: #e6f1f8;
  border-radius: 1.2rem;
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 150%;
  color: #333333;
}

@media only screen and (max-width: 1200px) {
  .order-info-container {
    margin-top: 2rem;
  }
}

.buttons-text {
  align-items: center;
  display: flex;
}

.refund-confirm-card {
  padding: 2rem;
  border-radius: 1.25rem !important;
}

.refund-confirm-title {
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  font-size: 1.5rem;
  line-height: 120%;
  letter-spacing: -0.015em;
  color: #0277bd;
  margin-bottom: 1rem;
}

.refund-confirm-text {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 1rem;
  line-height: 150%;
  color: #333333;
  margin-bottom: 1.5rem;
}

.refund-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.refund-confirm-button {
  border-radius: 1.25rem;
  font-family: 'Raleway', sans-serif;
  font-weight: bold;
  font-size: 1rem;
  line-height: 120%;
  letter-spacing: -0.015em;
  padding: 0.5rem 1.25rem;
  text-transform: uppercase;
  cursor: pointer;
}

.refund-confirm-button.cancel {
  box-sizing: border-box;
  color: #0277bd;
  border: 2px solid #0277bd;
  background-color: white;
}

.refund-confirm-button.confirm {
  color: white;
  background-color: #0277bd;
  border: 2px solid #0277bd;
}

.spinner {
  margin-left: 0.5rem;
  min-width: 1rem;
  width: 1rem;
  min-height: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #0277bd;
  animation: spin 1s linear infinite;
  -webkit-animation: spin 1s linear infinite;
  align-self: center;
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

@media only screen and (max-width: 425px) {
  .order-info-container {
    padding: 1.25rem 1.5rem;
  }

  .buttons-container {
    flex-direction: column;
  }

  .order-info-button.print {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
  }
}
</style>
